<template>
  <div class="course-box">
    <div class="course-box-title">
      {{ title }}
    </div>
    <div class="course-box-list">
      <lr-link
        class="course-box-list-item"
        :to="item.url"
        v-for="(item, index) in showData"
        :key="item.id"
        @click="$emit('content-click', item)"
      >
        <div class="course-box-list-item-title ellipsis">
          <icon
            type="iconic_title_play"
            class="course-box-list-item-title-icon"
          ></icon
          >{{ item.title }}
          <span
            class="course-box-list-item-title-hot-tag"
            v-show="hotNum && index < hotNum"
          >
            热
          </span>
        </div>
        <div class="course-box-list-item-info">
          <span class="course-box-list-item-time"
            >时长 {{ item.total_time }}</span
          >
          <span class="course-box-list-item-volume">
            {{ item.post_hits }}次已学
          </span>
        </div>
      </lr-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    data: {
      type: Array,
      default: () => [],
    },
    hotNum: { type: Number, default: () => 0 },
    isSeries: Boolean,
  },

  computed: {
    showData({ data, isSeries }) {
      if (!isSeries) return data;

      return data.map((item) => ({
        ...item,
        title: item.name,
        post_hits: item.total_post_hits,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.course-box {
  width: 278px;
  background: #ffffff;
  border: 1px solid #e8e8e8;

  &-title {
    @include flex-align-center();
    justify-content: space-between;
    height: 18px;
    line-height: 22px;
    padding-left: 16px;
    padding-right: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #222226;
    border-left: 4px solid #545454;
    margin: 14px 0;

    > span {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
    }
  }

  &-list-item {
    display: block;
    padding: 10px;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    &-title {
      position: relative;
      height: 17px;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 4px;
      color: #222226;
      padding-right: 28px;
      display: inline-block;
      vertical-align: middle;
      max-width: 100%;

      &-icon {
        font-size: 14px;
        width: 18px;
        height: 14px;
        margin-right: 6px;
        color: #777;
      }

      &-hot-tag {
        position: absolute;
        right: 0;
        display: inline-block;
        font-size: 12px;
        transform: scale(0.83);
        color: #fff;
        padding: 2px;
        line-height: 1;
        background: #eb5451;
        border-radius: 2px;
      }
    }

    &-info {
      @include flex-align-center();
      font-size: 12px;
      color: #888888;
      line-height: 17px;
      margin-left: 24px;
    }

    &-time {
      position: relative;
      padding-right: 10px;
      margin-right: 10px;

      &::after {
        position: absolute;
        height: 10px;
        content: '';
        border-right: 1px solid #d8d8d8;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>